export default "__VITE_ASSET__Dc59ESbI__"